import React from 'react';
import { 
  HelpCircle,
  Flower, 
  Droplet, 
  Clock, 
  CreditCard, 
  CalendarCheck, 
  ShoppingBag, 
  RefreshCw 
} from 'lucide-react';
import FAQSection from '../Components/FAQSection';
import FreeConsultationCTA from '../Components/FreeConsultationCTA';


const SpaFAQPage = () => {
  const massageServiceFAQs = [
    {
      question: "What types of massage services do you offer?",
      answer: "We offer a variety of massage services including Swedish, Deep Tissue, Hot Stone, Aromatherapy, and Couples Massage. Each massage is tailored to your specific needs and preferences."
    },
    {
      question: "How long are your massage sessions?",
      answer: "We offer massage sessions in 30, 60, and 90-minute durations. Our therapists can recommend the best duration based on your specific needs and areas of tension."
    },
    {
      question: "Do I need to book in advance?",
      answer: "We recommend booking in advance to ensure availability, especially during peak hours and weekends. However, we do accommodate walk-ins when possible."
    },
    {
      question: "What should I wear during a massage?",
      answer: "You can undress to your comfort level, and our professional therapists will ensure you are always appropriately draped."
    },
    {
      question: "Are your massage therapists licensed?",
      answer: "Yes, all our massage therapists are fully licensed and certified professionals with extensive training and experience in various massage techniques."
    }
  ];

  const skincareFAQs = [
    {
      question: "What skincare brands do you carry?",
      answer: "We offer unique, high-quality, cruelty-free skincare products that are carefully made with natural ingredients ensuring effective result."
    },
    {
      question: "Are your skincare products suitable for all skin types?",
      answer: "We provide products for various skin types, including sensitive, oily, dry, and combination skin."
    },
    {
      question: "Do you offer skincare consultation?",
      answer: "Yes! We provide completely free skincare consultations to help you develop a personalized skincare routine tailored to your unique skin concerns."
    },
    {
      question: "Can I return or exchange skincare products?",
      answer: `Due to the personal nature of skincare and hygiene considerations, we cannot accept returns or exchanges on opened skincare products. 
      We recommend carefully reviewing product details and consulting with our skincare specialist before making a purchase to ensure you select 
      the most suitable products for your skin.
      `
    },
    {
      question: "Do you offer product samples?",
      answer: `We understand the desire to try before you buy. While we do not currently offer free product samples, 
      our skincare specialist is available to provide detailed product information, ingredient breakdowns, and 
      personalized recommendations during our Free consultations to help you make the most informed purchasing decision.
      `
    }
  ];

  return (
    <div className="min-h-screen bg-accent-lighter font-body py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto pt-20">
        <div className="text-center mb-12">
          <HelpCircle className="mx-auto w-12 h-12 text-primary mb-4" />
          <h1 className="text-3xl md:text-4xl font-extrabold font-heading text-dim">Frequently Asked Questions</h1>
          <p className="mt-4 text-lg md:text-xl text-gray-600">
            Find answers to the most common questions about our services and products
          </p>
        </div>

        <FAQSection 
          title="Massage Services" 
          icon={Flower} 
          faqs={massageServiceFAQs} 
        />

        <FAQSection 
          title="Skincare Products" 
          icon={Droplet} 
          faqs={skincareFAQs} 
        />

        <FreeConsultationCTA />
      </div>
    </div>
  );
};

export default SpaFAQPage;